// convert px to rem
export const rem = px => {
  return `${px / 100}rem`
}
